package com.starparty.app.astro0

import com.starparty.app.vector_maths.Point2d

/**
 * Title:
 * Description:
 * Copyright:    Copyright (c) 2002
 * Company:
 * @author
 * @version 1.0
 */
class SphPoint : Point2d {
    constructor() : super() {}
    constructor(att: Double, elev: Double) : super(att, elev) {}
    constructor(sph: DoubleArray) : super(sph) {}
    constructor(p: Point2d) : super(p) {}

    var att: Double
        get() = x
        set(att) {
            x = att
        }

    var azm: Double
        get() = x
        set(azm) {
            x = azm
        }

    var rA: Double
        get() = x
        set(ra) {
            x = ra
        }

    var elv: Double
        get() = y
        set(elv) {
            y = elv
        }

    var alt: Double
        get() = y
        set(alt) {
            y = alt
        }

    var dec: Double
        get() = y
        set(dec) {
            y = dec
        }

}